import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carolina Méndez',
  role: 'Docente de 3.º de Primaria',
  location: 'Buenos Aires, Argentina',
  quote: 'Recuperé mis domingos. Antes pasaba horas armando fichas de matemáticas — ahora abro el tomo y en 5 minutos tengo la clase lista. Mis alumnos están más motivados que nunca.',
  initials: 'CM',
  color: '#2563EB'
}, {
  name: 'Lucía Fernández',
  role: 'Coordinadora académica',
  location: 'Madrid, España',
  quote: 'Lo mejor que invertí este año. Los ejercicios están perfectamente graduados por edad y nivel. Por fin tengo un material profesional para apoyar a mis docentes de Primaria.',
  initials: 'LF',
  color: '#F59E0B'
}, {
  name: 'Andrea Salas',
  role: 'Docente de 1.º a 4.º',
  location: 'Ciudad de México, México',
  quote: 'Pensé que era "otro PDF más", pero esto es otro nivel. Los 6 tomos están organizados por grado y bloque — encuentro lo que necesito al instante. Vale 10 veces lo que cuesta.',
  initials: 'AS',
  color: '#22C55E'
}, {
  name: 'Valentina Rojas',
  role: 'Docente de 5.º de Básica',
  location: 'Santiago, Chile',
  quote: 'Las evaluaciones con solucionario me ahorran horas cada bimestre. Mis alumnos progresan más rápido y yo dejé de sentirme agotada. Un antes y un después en mi aula.',
  initials: 'VR',
  color: '#EF4444'
}, {
  name: 'María José Castro',
  role: 'Docente & Tutora',
  location: 'Bogotá, Colombia',
  quote: 'Los recursos visuales para fracciones y geometría son oro puro. Los niños entienden conceptos abstractos al primer intento. Material profesional confiable a mano.',
  initials: 'MC',
  color: '#8B5CF6'
}, {
  name: 'Sofía Aguirre',
  role: 'Docente de 6.º Primaria',
  location: 'Lima, Perú',
  quote: 'Lo descargué un viernes y el lunes ya estaba dando clases con material nuevo. Compatible con tablet y para imprimir, así que lo uso en aula o lo proyecto. Súper práctico.',
  initials: 'SA',
  color: '#0EA5E9'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-235">
      {/* Soft pastel glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-236"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-237">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-238">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-239">
            ⭐ Testimonios reales
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-240">
            Lo que dicen los docentes{' '}
            <span className="text-primary" data-id="element-241">que ya lo usan</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-242">
            <span className="text-secondary text-base sm:text-lg" data-id="element-243">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-244">
              4.9/5 (+1,200 Reseñas Verificadas)
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-245">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(37,99,235,0.15)] flex flex-col relative" data-id="element-246">
              {/* Quote mark */}
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-247">
                "
              </span>

              {/* Stars */}
              <div className="text-secondary text-sm mb-3" data-id="element-248">⭐⭐⭐⭐⭐</div>

              {/* Quote */}
              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-249">
                {t.quote}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-250">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-251">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-252">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-253">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-254">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-255">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        {/* Bottom trust line */}
        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-256">
          Más de <span className="text-primary font-bold" data-id="element-257">3.400 colegios</span>{' '}
          en 14 países de habla hispana ya enseñan con MegaPack Matemática
          Lista™.
        </p>
      </div>
    </section>;
}